export const ServerConfiguration = {
  uploadUrl: "https://cms.myemporia.my/eCommerceCMSImage/upload.php",
  testingServerUrl: "https://magscholar.com/MagscholarAPI/api/magscholar/",
  // PROJECTID : 7
}